/* eslint-disable @typescript-eslint/no-explicit-any */
import { isArray } from 'class-validator';
import { cleanFolderName } from './clean-folder-name';
import { SPMakeOSCompanyExport } from './sp-makeos-company-export.model';

export interface ISPMakeOSProjectExport {
  _id: string;
  makeOSProjectId: string;
  name: string;
  projectNumber: string;
  company: SPMakeOSCompanyExport;
  createdAt: Date;
  updatedAt: Date;
  status: string;

  // departmentFoldersKeys?: Array<string>;
  spMakeFolderParts: string[];
}

export class SPMakeOSProjectExport implements ISPMakeOSProjectExport {
  _id: string;
  makeOSProjectId: string;
  name: string;
  projectNumber: string;
  company: SPMakeOSCompanyExport;
  createdAt: Date;
  updatedAt: Date;
  status: string;

  // departmentFoldersKeys: Array<string> = [];

  spMakeFolderParts: string[] = [];
  spMakeFoldersKeys: string[] = [];

  constructor(data: any) {
    this._id = data._id;
    this.makeOSProjectId = data.makeOSProjectId;
    if (typeof this.makeOSProjectId === 'undefined') {
      this.makeOSProjectId = typeof data._id === 'string' ? data._id : data._id.toString();
    }
    this.name = data.name;
    this.projectNumber = data.projectNumber;

    const getFromArray: boolean =
      typeof data !== 'undefined' && typeof data.company !== 'undefined' && isArray(data.company) && typeof data.company[0] !== 'undefined';
    const getFromSingleton: boolean =
      typeof data !== 'undefined' && typeof data.company !== 'undefined' && !isArray(data.company) && typeof data.company === 'object';
    this.company = new SPMakeOSCompanyExport({});
    if (getFromArray === true) {
      this.company = new SPMakeOSCompanyExport(data.company[0]);
    }
    if (getFromSingleton === true) {
      this.company = new SPMakeOSCompanyExport(data.company);
    }
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.status = data.status;
    this.spMakeFoldersKeys = typeof data.spMakeFoldersKeys !== 'undefined' ? data.spMakeFoldersKeys : [];
    this.spMakeFolderParts = this.getSPMakeFolderParts();
  }
  getSPMakeFolderParts = (): string[] => {
    const folderNameParts: string[] = [
      cleanFolderName(this.projectNumber.replace(/^1210-/gim, '')),
      '_',
      cleanFolderName(this.company.acronym),
      '_',
      cleanFolderName(this.name),
    ];
    const folderName = folderNameParts.join('').length > 70 ? folderNameParts.join('').substring(0, 70) : folderNameParts.join('');
    const folderParts = [cleanFolderName(this.company.acronym), folderName];
    return folderParts;
  };
}
